module.exports = __webpack_public_path__ + "871ddba569be1f90ae9d698b66dadf51.png";